import { getFirestore, collection, query, where, getDocs, updateDoc, doc } from 'firebase/firestore';

export const verifyPromoCode = async (code) => {
  try {
    const db = getFirestore();
    const codesRef = collection(db, 'promoCodes');
    const q = query(codesRef, where('code', '==', code), where('used', '==', false));
    const querySnapshot = await getDocs(q);

    if (querySnapshot.empty) {
      throw new Error('Invalid or already used promo code');
    }

    const codeDoc = querySnapshot.docs[0];
    return { id: codeDoc.id, ...codeDoc.data() };
  } catch (error) {
    console.error('Error verifying promo code:', error);
    throw error;
  }
};

export const markPromoCodeAsUsed = async (codeId, userId) => {
  try {
    const db = getFirestore();
    const codeRef = doc(db, 'promoCodes', codeId);

    await updateDoc(codeRef, {
      used: true,
      usedBy: userId,
      usedAt: new Date()
    });

    return true;
  } catch (error) {
    console.error('Error marking promo code as used:', error);
    throw error;
  }
};

export const checkPromoCodeValidity = async (code) => {
  try {
    const db = getFirestore();
    const codesRef = collection(db, 'promoCodes');
    const q = query(codesRef, where('code', '==', code), where('used', '==', false));
    const querySnapshot = await getDocs(q);

    return !querySnapshot.empty;
  } catch (error) {
    console.error('Error checking promo code validity:', error);
    throw error;
  }
};